// extracted by mini-css-extract-plugin
module.exports = {"quoteText":"Highlight_quoteText__0h_JC","titleWrapper":"Highlight_titleWrapper__KkyBN","title":"Highlight_title__bL5Bg","quoteBody":"Highlight_quoteBody__uBj7j"};